/* src/app/shared/ui/components/buttons/cancel-button/cancel-button.component.scss */
.container {
  display: inline-block;
  outline: none;
  height: 21px;
  width: 21px;
}
.container:focus ::ng-deep .cancel-button__background {
  fill: #2a56c9;
}
.container:focus ::ng-deep .cancel-button__border {
  color: #2a56c9;
}
.container:focus ::ng-deep .cancel-button__icon {
  color: #ffffff;
}
.container__icon {
  width: 21px !important;
  height: 21px !important;
  cursor: pointer;
}
.container__icon ::ng-deep .cancel-button__background {
  transition: fill 0.15s linear;
}
.container__icon ::ng-deep .cancel-button__border {
  color: #2a56c9;
}
.container__icon ::ng-deep .cancel-button__icon {
  color: #2a56c9;
  transition: color 0.15s linear;
}
.container__icon:hover ::ng-deep .cancel-button__background {
  fill: #2a56c9;
}
.container__icon:hover ::ng-deep .cancel-button__border {
  color: #2a56c9;
}
.container__icon:hover ::ng-deep .cancel-button__icon {
  color: #ffffff;
}
.container__icon--disabled ::ng-deep .cancel-button__background {
  fill: #ffffff !important;
}
.container__icon--disabled ::ng-deep .cancel-button__border {
  color: #b4b4b4 !important;
}
.container__icon--disabled ::ng-deep .cancel-button__icon {
  color: #b4b4b4 !important;
}
.container__icon--disabled:hover {
  cursor: not-allowed;
}
.container__icon--disabled:hover ::ng-deep .cancel-button__background {
  fill: #ffffff;
}
.container__icon--disabled:hover ::ng-deep .cancel-button__border {
  color: #b4b4b4;
}
.container__icon--disabled:hover ::ng-deep .cancel-button__icon {
  color: #b4b4b4;
}
/*# sourceMappingURL=cancel-button.component.css.map */
